import MomentUtils from "@date-io/moment";
import "@fortawesome/fontawesome-free/css/all.css";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core";
import { ptBR } from "@material-ui/core/locale";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import "moment/locale/pt-br";
import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import "stylesheets/mercatorio-box.css.scss";
import "stylesheets/mercatorio-colors.css.scss";
import "stylesheets/mercatorio-custom.css.scss";
import "stylesheets/mercatorio-fonts.css.scss";
import useAuth from "../hooks/auth";
import AxiosProvider from "./axios-provider";
import {
  Homepage,
  UserConfig,
  UserPasswordRecovery,
  UserPasswordUpdate,
  UserProfile,
} from "./pages";
import PrivateRoute from "./private-route";
import { Analysis, Api, CRM, Dashboard, Query } from "./products";
import { NavbarLoggedIn } from "./ui/navbar";

moment.locale("pt-br");

const theme = createMuiTheme({}, ptBR);

export default () => {
  const queryClient = new QueryClient();

  const { isAuthenticated } = useAuth();

  return (
    <MuiThemeProvider theme={theme}>
      <MuiPickersUtilsProvider
        utils={MomentUtils}
        libInstance={moment}
        locale="pt-br"
      >
        <QueryClientProvider client={queryClient}>
          {process.env.NODE_ENV === "development" && (
            <ReactQueryDevtools initialIsOpen={false} />
          )}

          <BrowserRouter>
            <AxiosProvider />
            {isAuthenticated && <NavbarLoggedIn />}

            <Switch>
              <Route
                path="/"
                component={isAuthenticated ? Dashboard : Homepage}
                exact
              />

              <Route
                path="/recuperar_senha"
                component={UserPasswordRecovery}
                exact
              />

              <PrivateRoute
                path="/usuario/config"
                component={UserConfig}
                exact
              />

              <PrivateRoute
                path="/usuario/alterar_senha"
                component={UserPasswordUpdate}
                exact
              />

              <PrivateRoute
                path="/usuario/meu_perfil"
                component={UserProfile}
                exact
              />

              <PrivateRoute path="/analise" component={Analysis} exact />
              <PrivateRoute path="/api" component={Api} exact />
              <PrivateRoute path="/busca" component={Query} exact />
              <PrivateRoute path="/negocios" component={CRM} exact />
              <PrivateRoute path="/painel" component={Dashboard} exact />

              <Redirect to="/" />
            </Switch>
          </BrowserRouter>
        </QueryClientProvider>
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  );
};
